import { observer } from 'mobx-react';
import * as React from 'react';

import { SelectFilterWithSearch } from 'components/Filter/DefaultFilters';

import { countriesStore } from 'stores';

import { formatCountry } from '../presenters';

type Props = {
  value: string | number | nil;
} & FilterProps;

@observer
class CountryIdComponent extends React.Component<Props> {
  options = () => countriesStore.modelValues.map((country) => country.forSelect());

  render() {
    const { props } = this;
    return <SelectFilterWithSearch {...props} options={this.options()} />;
  }
}

export const countryId: FilterListDescriptor = {
  filter: {
    persistance: {
      handler: '=',

      calcValue: function (name, value) {
        return value;
      },

      prettify: function (_name, value) {
        return formatCountry(value);
      },
    },
  },
  frontend: {
    type: 'custom',
    component: CountryIdComponent,
  },
};
